export default __webpack_public_path__ + "static/media/back_on_over.026b4a10.svg";